import { Link } from "react-router-dom";
import { useLang } from "@/i18n/LanguageContext";
import LanguageSwitcher from "@/components/LanguageSwitcher";
import useHeaderScroll from "@/lib/useHeaderScroll";
import { RE_BASE } from "@/lib/routes";

export default function RENav({ theme = "light", word = "", links = [] }) {
  const dark = theme === "dark";
  const { scrolled, hidden } = useHeaderScroll();

  return (
    <>
    <header
      className={`fixed top-0 inset-x-0 z-40 transition-[transform,background-color,border-color,backdrop-filter] duration-300 ease-out ${
        hidden ? "-translate-y-full" : "translate-y-0"
      } ${
        scrolled
          ? dark
            ? "bg-ink/85 backdrop-blur-xl border-b border-paper/10"
            : "bg-stone/85 backdrop-blur-xl border-b border-charcoal/10"
          : "bg-transparent border-b border-transparent"
      }`}
      data-testid="re-nav"
    >
      <div className="mx-auto max-w-[1180px] pl-6 pr-4 md:px-8 py-4 flex items-center justify-between">
        <Link to={RE_BASE} data-testid="re-nav-home" className="flex items-center gap-3 group">
          <img src="/assets/medallion.png" alt="Eagle Eyes medallion" className="h-11 w-11 transition-transform duration-500 group-hover:rotate-[12deg]" />
          <span className="flex flex-col">
            <span className={`font-heading font-semibold uppercase tracking-[0.14em] text-[1.05rem] leading-[1.02] transition-opacity group-hover:opacity-70 ${dark ? "text-paper" : "text-charcoal"}`}>
              Eagle Eyes
            </span>
            <span className={`font-mono-data text-[0.56rem] tracking-[0.32em] leading-[1.1] mt-[2px] ${dark ? "text-brass" : "text-crimson"}`}>
              {word.toUpperCase()}
            </span>
          </span>
        </Link>
        <div className="absolute right-4 top-4 sm:hidden"><LanguageSwitcher variant="re" /></div>
      </div>
    </header>
    {/* Desktop: links + language button pinned to the top-right corner, same as the Real Estate landing */}
    <nav className="hidden sm:flex fixed top-4 right-4 z-50 items-center gap-4 md:gap-6">
      {links.map((l, i) => (
        <a
          key={l.href}
          href={l.href}
          data-testid={`re-nav-section-${i}`}
          className={`font-mono-data text-[0.62rem] tracking-[0.2em] opacity-60 transition-opacity hover:opacity-100 ${dark ? "text-paper" : "text-charcoal"}`}
        >
          {l.label.toUpperCase()}
        </a>
      ))}
      <LanguageSwitcher variant="re" />
    </nav>
    </>
  );
}
